<template>
  <div class="box">
    <div v-if="!fundingComplete">
      <h3 class=" title is-6 has-text-weight-light">
        <span>Votre demande de financement est-elle accordée ?</span>
      </h3>
      <div class="radio-group">
        <label>
          <input
              v-model="order.funding.funding_accepted"
              type="radio"
              name="visa"
              :value="1"
          >
          <div class="choice">
            <span>Oui</span>
          </div>
        </label>
        <label>
          <input
              v-model="order.funding.funding_accepted"
              type="radio"
              name="visa"
              :value="0"
          >
          <div class="choice">
            <span>Non</span>
          </div>
        </label>
      </div>

      <h3
          v-if="fundingAccepted === 0"
          class=" title is-6 has-text-weight-light p-t-md"
      >
        <span>Veuillez déposez les documents confirmant le refus de votre demande</span>
      </h3>
      <h3
          v-if="fundingAccepted === 1"
          class=" title is-6 has-text-weight-light p-t-md"
      >
        <span>Veuillez déposez les documents confirmant l'acceptation de votre demande</span>
      </h3>
      <dropzone
          v-if="fundingAccepted !== null"
          id="funding-docs"
          :options="dropzoneOpt"
          :preview-template="template"
          @vdropzone-sending="sendingEvent"
          @vdropzone-success="showSuccess"
          @vdropzone-removed-file="removeDocument"
      />

      <div class="p-t-md">
        <transition name="slide-fade">
          <div class="has-text-danger has-text-centered">
            {{ errorMsg }}
          </div>
        </transition>
        <button
            v-if="user.isLoggedIn"
            :class="'button-valid button ' + isLoading"
            @click="confirmFunding()"
        >
          Sauvegarder
        </button>
        <button
            v-else
            class="button"
            disabled
        >
          Sauvegarder
        </button>
      </div>
    </div>

    <div v-else>
      <h3
          v-if="fundingAccepted === 0"
          class="is-4 has-text-weight-light"
      >
        <span>Votre demande de financement est refusée, vous avez fourni les documents suivants</span>
      </h3>
      <h3
          v-if="fundingAccepted === 1"
          class="is-4 has-text-weight-light"
      >
        <span>Votre demande de financement est acceptée, vous avez fourni les documents suivants</span>
      </h3>

      <div class="column">

        <div
            v-for="doc in order.funding.funding_orgas"
            :key="doc.id"
        >
          <span class="doc-filename"><a
              class="doc-remove"
              @click="deleteDocument(doc)"
          >
            <i class="fa fa-trash"/></a> <a
              :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
              target="_blank"
          >{{ doc.original_file_name }}</a></span>
        </div>
      </div>

      <div class="has-text-right p-t-md">
        <transition name="slide-fade">
          <div class="has-text-danger has-text-centered">
            {{ errorMsg }}
          </div>
        </transition>
        <button
            v-if="user.isLoggedIn"
            :class="'button ' + isLoading"
            @click="fundingComplete = false"
        >
          Ajouter des documents
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import api from 'services/candidate'
import Dropzone from 'vue2-dropzone'

const AUTH_TOKEN = localStorage.getItem('token')

export default {
  components: {
    Dropzone
  },
  filters: {
    json(value) {
      return JSON.stringify(value, null, 2)
    }
  },
  props: {
    school: {type: Object},
    order: {type: Object},
    candidate: {type: Object},
    application: {type: Object},
  },
  data() {
    return {
      isLoading: '',
      isAddressLoading: '',
      errorMsg: '',
      errorAddressMsg: '',
      totalDocuments: 0,
      fundingComplete: false,
      editAddress: false,
      returnAddress: {
        name: null,
        address: null,
        address_complement: null,
        post_code: null,
        city: null,
        country: 'France'
      },
      csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
      csrfHeader: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
        'Authorization': `Bearer ${AUTH_TOKEN}`
      },
      dropzoneOpt: {
        url: '//' + window.location.hostname + '/api/candidate/application/add_funding_document',
        dictDefaultMessage: '<i class=\'fa fa-cloud-upload\'></i><br>' + this.$t('candidate.documents.document_drag'),
        dictRemoveFile: this.$t('labels.general.delete'),
        dictMaxFilesExceeded: this.$t('candidate.documents.validation.max_doc'),
        dictFileTooBig: this.$t('candidate.documents.validation.size_doc') + ' ({{filesize}}MiB). Maximum: {{maxFilesize}}MiB.',
        dictCancelUpload: this.$t('labels.general.cancel'),
        maxFiles: 6,
        maxFilesize: 10,
        headers: this.csrfHeader
      },
      documentsList: []
    }
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      token: 'auth/getToken',
      account: 'auth/getAccount'
    }),
    ...mapState({
      user: 'auth'
    }),
    fundingAccepted() {
      return this.order.funding && this.order.funding.funding_accepted
    },
    docExist() {
      if (this.order.funding && this.order.funding.funding_orgas.length) {
        return true
      }
    },
  },
  methods: {
    ...mapActions({
      fundingConfirmation: 'candidate/fundingConfirmation',
      fundingDocRemove: 'candidate/fundingDocRemove',
      fundingAdminValidation: 'candidate/validateVisaDocument'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    fileAdded() {
      this.totalDocuments++
    },
    confirmFunding: function () {

      if (this.order.funding.funding_accepted === null) {
        this.errorMsg = 'Votre demande est-elle acceptée ?'
        return
      }
      if (this.totalDocuments === 0 && _.isEmpty(this.order.funding.funding_orgas)) {
        this.errorMsg = 'Vous n\'avez ajouté aucun document'
        return
      }
      this.toggleLoading()
      this.fundingConfirmation(this.order.funding).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          this.errorMsg = ''
          this.fundingComplete = true
          this.$emit('send')
        } else if (this.status === 403) {
          this.toggleLoading()
        } else {
          this.toggleLoading()
          this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
        }
      }).catch(() => {
        this.toggleLoading()
        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
      })
    },

    deleteDocument(file) {
      let docToRemove;
      api.removeFundingDocument(file).then((result) => {

        if (result.status === 200) {
          this.order.funding.funding_orgas.forEach(function (doc) {
            if (file.id === doc.id) {
              docToRemove = doc;
            }
          })
          this.fundingDocRemove(docToRemove)
        }

      }).catch(e => {

      })
    },
    validateFunding: function () {
      this.toggleLoading()
      const funding = {}
      funding.id = this.order.funding.id
      funding.application = this.application
      funding.funding = this.order.funding
      this.fundingAdminValidation(funding).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          this.fundingComplete = true
          this.$emit('send')
        } else if (this.status === 403) {
          this.toggleLoading()
          this.$emit('notAuthenticated')
        } else {
          this.toggleLoading()
          this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
        }
      }).catch(() => {
        this.toggleLoading()
        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
      })
    },
    showSuccess(file) {
      this.errorMsg = ''
      this.documentsList.push(file)
      this.totalDocuments++
    },
    removeDocument(file, error, xhr) {
      if (file.xhr && this.application.docComplete === false) {
        const response = JSON.parse(file.xhr.response)
        api.removeFundingDocument(response).then((result) => {

        }).catch(e => {

        })
      }
    },
    sendingEvent(file, xhr, formData) {
      formData.append('order_id', this.order.id);
      formData.append('candidate_id', this.candidate.id);
      formData.append('user_id', this.candidate.user.id);
    },
    template: function () {
      return `
                  <div class="dz-preview dz-file-preview">
                      <div class="dz-image" style="width: 50px;height: 50px">
                          <img data-dz-thumbnail /></div>
                      <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                      </div>
                      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                      <div class="dz-error-message"><span data-dz-errormessage></span></div>
                      <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                      <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                  </div>
              `
    }
  },
  watch: {
    order: {
      immediate: true,
      handler(newOrder) {
        if (newOrder && newOrder.funding) {
          this.fundingComplete = this.docExist;
        }
      },
    },
  },
  created() {
    if (this.docExist) {
      this.fundingComplete = true
    }
  }
}
</script>

<style lang="scss">

.doc-type {
  min-height: 5rem;
  color: #0f1e44
}

.doc-type-title {
  margin-bottom: 0.3em;
}

.doc-type-subtitle {
  color: #0f1e44;
  font-style: italic;
  font-size: 0.9rem;
  /*max-width: 15rem;*/
}


</style>
